<div class="modal fade in" id="manage-groups-dialog" role="dialog">

	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header" id="manageGroupsDialogHeader">
				<button type="button" class="close" (click)="hide()"><i class="fa fa-times" aria-hidden="true"></i></button>
				<h4 class="modal-title"><em class="fa fa-th" aria-hidden="true"></em> GROUPS</h4>
			</div>
			<div class="modal-body">
					<div class="page-button">
					<button type="button" class="btn btn-primary" (click)="addNewGroupClicked()"><i class="fa fa-plus"></i> ADD NEW GROUP</button>
					<div class="btn-group edgefinityHeader">
						<button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="fa fa-th"></i> OPTIONS <span class="caret"></span></button>
						<ul class="dropdown-menu">
							<li [class.disabled]="!isSingleGroupSelected()" (click)="editSelectedGroup()"><a><i class="fa fa-pencil"></i> EDIT</a></li>
							<li [class.disabled]="!isAnyGroupsSelected()" (click)="deleteSelectedGroups()"><a><i class="fa fa-remove"></i> DELETE</a></li>
						</ul>
					</div>
				</div>
				<div id="groupForm">
					<ng-container *ngIf="mGroup != null">
						<div class="well">
							<div class="row">
							<label class="control-label col-sm-3">NAME:</label>
							<span class="col-sm-9"><input type="text" class="form-control" [(ngModel)]="mGroup.name"></span>
							<label class="control-label col-sm-3">DESCRIPTION:</label>
							<span class="col-sm-9"><input type="text" class="form-control" [(ngModel)]="mGroup.description"></span>
							<span align="right" class="col-sm-12 page-button" *ngIf="mGroup.id == null"><button type="button" class="btn btn-primary" (click)="addGroupClicked()"><i class="fa fa-plus"></i> ADD GROUP</button></span>
							<span align="right" class="col-sm-12 page-button" *ngIf="mGroup.id != null"><button type="button" class="btn btn-primary" (click)="updateGroupClicked()"><i class="fa fa-refresh"></i> UPDATE GROUP</button></span>
							</div>
						</div>
					</ng-container>
				</div>
				<div>
					<table id="groupTable" class="table table-hover" role="grid">
						<thead>
							<tr class="header tablesorter-headerRow" role="row">
								<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted table-checkbox" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="groupTable" unselectable="on" aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort" style="user-select: none;">
									<div class="tablesorter-header-inner">&nbsp;</div>
								</th>
								<th class="header tablesorter-header tablesorter-headerUnSorted" data-column="1" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="groupTable" unselectable="on" aria-sort="none" aria-label="NAME: No sort applied, activate to apply an ascending sort">
									<div class="tablesorter-header-inner">NAME</div>
								</th>
								<th class="header tablesorter-header tablesorter-headerUnSorted" data-column="2" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="groupTable" unselectable="on" aria-sort="none" aria-label="DESCRIPTION: No sort applied, activate to apply an ascending sort">
									<div class="tablesorter-header-inner">DESCRIPTION</div>
								</th>
							</tr>
						</thead>
						<tbody id="groupTableBody" aria-live="polite" aria-relevant="all">
							<ng-container *ngIf="mGroups != null">
								<ng-container *ngFor="let group of mGroups">
									<tr>
										<td><div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [(ngModel)]="group.mSelected"><label for="checkbox"></label></div></td>
										<td>{{group.mGroup.name}}</td>
										<td>{{group.mGroup.description}}</td>
									</tr>
								</ng-container>
							</ng-container>
						</tbody>
					</table>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> CLOSE</button>
			</div>
		</div>
	</div>
</div>

<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>